import React, { useState, useEffect } from 'react';
import { RiMoonFill, RiSunFill } from 'react-icons/ri';

export default function FixedPlugin(props) {
  const { ...rest } = props;
  const initialDarkMode = localStorage.getItem('darkmode') === 'true';
  const [darkmode, setDarkmode] = useState(initialDarkMode);

  useEffect(() => {
    document.body.classList.toggle('dark', darkmode);
    localStorage.setItem('darkmode', darkmode.toString());
  }, [darkmode]);

  return (
    <button
      className="border-px fixed bottom-[30px] right-[35px] !z-[99] flex h-[60px] w-[60px] items-center justify-center rounded-full border-[#6a53ff] bg-gradient-to-br from-brandLinear to-blueSecondary p-0"
      onClick={() => {
        // Toggle dark mode state
        setDarkmode((prevDarkmode) => !prevDarkmode);
      }}
      {...rest}
    >
      <div className="cursor-pointer text-gray-600">
        {darkmode ? (
          <RiSunFill className="h-4 w-4 text-white" />
        ) : (
          <RiMoonFill className="h-4 w-4 text-white" />
        )}
      </div>
    </button>
  );
}
